import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteGalleryEntry,
  getCategoryNames,
  getGalleryEntryByWidgetId,
  postGalleryEntry,
  putGalleryEntry
} from "apis/widgetGalleryApi";
import { RequestState } from "common/RequestState";

const initialState = (widget = {}) => {
  if (!widget._requestState) {
    widget._requestState = {
      Create: RequestState.NotRequested,
      Read: RequestState.NotRequested,
      Update: RequestState.NotRequested,
      Delete: RequestState.NotRequested
    };
  }
  return widget;
};

export const requestCategoryNames = createAsyncThunk("widgetGallery/categoryNames", async () => {
  return await getCategoryNames();
});

export const requestGalleryEntry = createAsyncThunk("widgetGallery/read", async id => {
  return await getGalleryEntryByWidgetId(id);
});

export const requestGalleryEntryCreate = createAsyncThunk("widgetGallery/create", async payload => {
  return await postGalleryEntry(payload);
});

export const requestGalleryEntryUpdate = createAsyncThunk("widgetGallery/update", async payload => {
  return await putGalleryEntry(payload);
});

export const requestGalleryEntryDelete = createAsyncThunk("widgetGallery/delete", async id => {
  return await deleteGalleryEntry(id);
});

export const widgetGallerySlice = createSlice({
  name: "widgetGallery",
  initialState: {
    categories: {
      _requestState: RequestState.NotRequested
    },
    widgets: {}
  },
  reducers: {},
  extraReducers: {
    [requestCategoryNames.pending]: state => {
      state.categories._requestState = RequestState.InProgress;
    },
    [requestCategoryNames.fulfilled]: (state, action) => {
      state.categories = { names: action.payload, _requestState: RequestState.Finished };
    },
    [requestCategoryNames.rejected]: state => {
      state.categories = { _requestState: RequestState.Failed };
    },

    [requestGalleryEntry.pending]: (state, action) => {
      state.widgets[action.meta.arg] = initialState(state.widgets[action.meta.arg]);
      state.widgets[action.meta.arg]._requestState.Read = RequestState.InProgress;
    },
    [requestGalleryEntry.fulfilled]: (state, action) => {
      state.widgets[action.meta.arg] = {
        ...(action.payload || {}),
        ...{ _requestState: state.widgets[action.meta.arg]._requestState }
      };
      state.widgets[action.meta.arg]._requestState.Read = RequestState.Finished;
    },
    [requestGalleryEntry.rejected]: (state, action) => {
      state.widgets[action.meta.arg]._requestState.Read = RequestState.Failed;
    },

    [requestGalleryEntryCreate.pending]: (state, action) => {
      const id = action.meta.arg.widgetId;
      state.widgets[id] = initialState(state.widgets[id]);
      state.widgets[id]._requestState.Create = RequestState.InProgress;
    },
    [requestGalleryEntryCreate.fulfilled]: (state, action) => {
      const id = action.meta.arg.widgetId;
      state.widgets[id] = {
        ...action.payload,
        ...{ _requestState: state.widgets[id]._requestState }
      };
      state.widgets[id]._requestState.Read = RequestState.Finished;
      state.widgets[id]._requestState.Create = RequestState.Finished;
    },
    [requestGalleryEntryCreate.rejected]: (state, action) => {
      const id = action.meta.arg.widgetId;
      state.widgets[id]._requestState.Create = RequestState.Failed;
    },

    [requestGalleryEntryUpdate.pending]: (state, action) => {
      const id = action.meta.arg.widgetId;
      state.widgets[id] = initialState(state.widgets[id]);
      state.widgets[id]._requestState.Update = RequestState.InProgress;
    },
    [requestGalleryEntryUpdate.fulfilled]: (state, action) => {
      const id = action.meta.arg.widgetId;
      state.widgets[id] = {
        ...action.payload,
        ...{ _requestState: state.widgets[id]._requestState }
      };
      state.widgets[id]._requestState.Update = RequestState.NotRequested;
    },
    [requestGalleryEntryUpdate.rejected]: (state, action) => {
      const id = action.meta.arg.widgetId;
      state.widgets[id]._requestState.Update = RequestState.Failed;
    },

    [requestGalleryEntryDelete.pending]: (state, action) => {
      state.widgets[action.meta.arg] = initialState(state.widgets[action.meta.arg]);
      state.widgets[action.meta.arg]._requestState.Delete = RequestState.InProgress;
    },
    [requestGalleryEntryDelete.fulfilled]: (state, action) => {
      delete state.widgets[action.meta.arg];
    },
    [requestGalleryEntryDelete.rejected]: (state, action) => {
      state.widgets[action.meta.arg]._requestState.Delete = RequestState.Failed;
    }
  }
});
